// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2Ure3","rotation":"Loader_rotation__cP1x5","inverted":"Loader_inverted__sWe6Q"};